/// <amd-module name="SuiteCommerce.SizeChart.NotFoundPage.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.SizeChart.NotFoundPage.View", ["require", "exports", "Backbone", "suitecommerce_size_chart_not_found_page.tpl", "SuiteCommerce.SizeChart.Common.Utils"], function (require, exports, Backbone_1, NotFoundViewTemplate, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.NotFoundView = void 0;
    var NotFoundView = /** @class */ (function (_super) {
        __extends(NotFoundView, _super);
        function NotFoundView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = NotFoundViewTemplate;
            _this.title = Utils_1.Utils.translate('Page not found');
            return _this;
        }
        NotFoundView.prototype.getContext = function () {
            return {
                pageHeader: this.title,
            };
        };
        return NotFoundView;
    }(Backbone_1.View));
    exports.NotFoundView = NotFoundView;
});
